import { CLOUD_TRANSCODE_SUPPORTED_FORMATS } from './FJCloudTranscodingData';

export const UPLOAD_FILE_TYPE =
    'image/xbm,image/tiff,image/apng,image/jpg,image/jpeg,image/ico,image/jfif,image/webp,image/png,image/bmp,image/gif';
export const TASK_POLLING_INTERVAL = 1 * 1000; //任务轮询时间
export const MAX_COMPRESS_IMAGE_SIZE = 2000;
export const MAX_POLLING_ERROR_TIME = 5;
export const UPLOAD_FILE_TYPE_NO_GIF =
    'image/xbm,image/tiff,image/apng,image/jpg,image/jpeg,image/ico,image/jfif,image/webp,image/png,image/bmp';
export const UPLOAD_FILE_TYPE_IMAGE_EXTENDER = '.jfif,.jpg,.webp,.jpeg,.png,.tiff,.bmp';

export const UPLOAD_FILE_TO_VIDEO = 'image/png,image/jpg,image/jpeg,image/jfif,image/webp,image/bmp, image/tiff';

export const UPLOAD_FILE_TYPE_OF_AUDIO = 'audio/mpeg,audio/wav';
export const TEXT_TO_VIDEO_POLLING_INTERVAL = 2 * 1000; //任务轮询时间

export const UPLOAD_FILE_TYPE_VIDEO = 'video/mp4,video/avi,video/mkv';
export const UPLOAD_FILE_TYPE_PPT = '.pptx,.ppt,.pdf';
export const UPLOAD_FILE_TYPE_PRODUCE_IMAGE =
    'image/xbm,image/apng,image/jpg,image/jpeg,image/ico,image/jfif,image/webp,image/png,image/bmp';

export const DEFAULT_FILE_TYPES = ['application/octet-stream', 'binary/octet-stream'];

/**
 * @deprecated 头像生成器上传文件类型
 * 使用 CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_IMAGES 代替
 */
export const HEADSHOT_GENERATOR_UPLOAD_FILE_TYPE = 'image/jpg,image/jpeg,image/png';

/**
 * 上传图片文件类型，不需要转码的文件类型, 没有 tiff, ico, xbm
 */
export const UPLOAD_IMAGE_FILE_TYPE_NO_NEED_TRANSCODE =
    'image/apng,image/jpg,image/jpeg,image/jfif,image/webp,image/png,image/bmp,image/gif';

// 云转码支持的文件 扩充类型， 添加到 input[type='file'] accept 中以支持云转码
export const CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_IMAGES =
    ',.' + CLOUD_TRANSCODE_SUPPORTED_FORMATS.image.input.join(',.');
export const CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_VIDEOS =
    ',.' + CLOUD_TRANSCODE_SUPPORTED_FORMATS.video.input.join(',.');
export const CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_AUDIOS =
    ',.' + CLOUD_TRANSCODE_SUPPORTED_FORMATS.audio.input.join(',.');
